import api from './api';
import { STORY } from './endpoints';

const get = params => api.get(`${STORY}/`, { params });

const getById = (id, params = {}) => api.get(`${STORY}/${id}`, { params });

const getBySlug = (slug, params = {}) =>
  api.get(`${STORY}/link/${slug}`, { params });

const post = story => {
  console.log(JSON.stringify(story));
  // alert("please post");
  api.post(`${STORY}/`, story);
}

const put = story => {
  console.log(JSON.stringify(story));
  // alert("please put");
  api.put(`${STORY}/`, story);
}

export default {
  get,
  getById,
  getBySlug,
  post,
  put,
};
